import { forwardRef } from 'react'
import { cn } from '~/lib/utils'

export const ExpandIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>(({ className, ...props }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    ref={ref}
    className={cn(className || '', 'size-4 shrink-0 opacity-50')}
    {...props}
  >
    <polyline
      points="6 9 12 15 18 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))

ExpandIcon.displayName = 'ExpandIcon'
